const USERS_UPDATED = (state, users) => { state.users = users }
const LOADING_UPDATED = (state, bool = true) => { state.loading = bool }
const USER_UPDATED = (state, user) => { state.user = user }

export default {
  USERS_UPDATED,
  USER_UPDATED,
  LOADING_UPDATED
}



// WEBPACK FOOTER //
// ./src/store/modules/users/mutations.js